export const useUserData = defineStore('usersData', () => {
  const runtimeConfig = useRuntimeConfig()

  const authStore = useAuthStore()
  const { userAuth, isLoginStatus } = storeToRefs(authStore)

  const {
    data: userData,
    error,
    pending,
    refresh
  } = useAsyncData(
    'coreUserData',
    async () => {
      if (!isLoginStatus.value || !userAuth.value) {
        return null
      }

      try {
        const res = await $fetch<{ success: boolean; data: UserData }>(
          `${runtimeConfig.public.apiUrl}/esim/v1/account`,
          {
            method: 'GET',
            credentials: 'include',
            headers: {
              'content-type': 'application/json',
              'Cache-Control': 'no-cache',
              authorization: `Bearer ${userAuth.value}`,
              // 제휴 3시간 채널 진입 시에만 값이 있어 AFFILIATE 쿠폰 기준으로 조회된다 (그 외 빈 객체)
              ...useCouponScope().getPartnersKeyHeader()
            }
          }
        )

        if (!res?.success) {
          userAuth.value = null
          throw new Error('Failed to fetch userData')
        }

        return res.data || null
      } catch (err: any) {
        // 401 Unauthorized: 토큰 만료 또는 유효하지 않음
        if (err?.statusCode === 401) {
          authStore.handleUnauthorized()
        }
        return null
      }
    },
    {
      watch: [isLoginStatus, userAuth]
    }
  )

  return {
    userData,
    error,
    pending,
    refresh
  }
})
